import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import {computed, toRef} from 'vue'
import {AgBoxS} from '@/components/ag'
import ClubDeal from './ClubDeal.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  isLogin: {type: Boolean},
  list: {default: () => ([]), type: Array},
},
  emits: ['open'],
  setup(__props, { emit: emits }) {

const props = __props





const list = toRef(props, 'list')

const computedList = computed(() => {
  return list.value.map((item) => {
    return {
      backgroundImg: item.cardBgUrl,
      id: item.partnershipId,
      kind: item.partnershipStatus,
      openingDate: item.dueDateFrom,
      pricePerStock: item.purchasePrice,
      progress: Number(item.collectedRate ?? 0),
      title: item.partnershipName,
    }
  })
})

const onOpen = (payload) => {
  emits('open', payload)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), {
    class: "box",
    css: {dp: 'flex', direction: 'row', overflowX: 'auto', overflowY: 'none', width: '100%'}
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedList), (item) => {
        return (_openBlock(), _createBlock(ClubDeal, _mergeProps({
          key: item.id,
          "is-login": __props.isLogin
        }, item, { onOpen: onOpen }), null, 16, ["is-login"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})